// extracted by mini-css-extract-plugin
export var alignCenter = "_bb-d";
export var bannerShown = "_bb-6";
export var buttonContent = "_bb-0";
export var cardList = "_bb-1";
export var centerContent = "_bb-2";
export var chevron = "_bb-3";
export var closePanelButton = "_bb-k";
export var conversationContextContainer = "_bb-l";
export var conversationDetailContainer = "_bb-4";
export var detailWrapper = "_bb-7";
export var dropdownButton = "_bb-e";
export var dropdownTitle = "_bb-9";
export var fullHeight = "_bb-5";
export var hidden = "_bb-a";
export var icon = "_bb-b";
export var mergeSuggestionWrapper = "_bb-m";
export var panel = "_bb-i";
export var portalButtonsWrapper = "_bb-c";
export var right = "_bb-j";
export var tableSummaryContainer = "_bb-8";
export var tableSummaryHeader = "_bb-g";
export var threeDotsButton = "_bb-f";
export var wide = "_bb-h";